export default __webpack_public_path__ + "static/media/rangerbg.54a8a579.jpg";